/*
 * File: DateInput.tsx
 * Author: Austin Robinson
 * Date Created: 10/18/2023
 * Copyright (c) DrivingDoc 2023
 */
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import { DateField, DateFieldProps } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends Omit<DateFieldProps<Dayjs>, 'variant'> {
  name: string;
  label: string;
}

export default function DateInput({ name, label, ...props }: PropTypes) {
  const { control } = useFormContext();
  return (
    <Box>
      {label && (
        <Typography
          component={InputLabel}
          htmlFor={name}
          variant="subtitle1"
          color="text.primary"
          fontWeight={700}
          disabled={props.disabled}
        >
          {label}
        </Typography>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <DateField
            id={name}
            slotProps={{
              textField: {
                variant: 'outlined',
                fullWidth: true,
                InputLabelProps: { shrink: true },
                color: fieldState.error ? 'error' : 'primary',
                helperText: fieldState.error?.message,
                onBlur: field.onBlur,
                error: !!fieldState.error,
              },
            }}
            inputRef={field.ref}
            value={field.value ? dayjs(field.value) : null}
            onChange={(value) => {
              if (value?.isValid()) {
                const newValue = dayjs(value).format('YYYY-MM-DD');
                console.log('Change Date To: ', newValue);
                field.onChange(newValue);
              }
            }}
            {...props}
          />
        )}
      />
    </Box>
  );
}
